<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-nav *ngIf="!!previousPageTitle">
      <glxy-page-nav-button
        [previousPageTitle]="previousPageTitle"
        [previousPageUrl]="previousPageURL"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ pageTitle$ | async }}</glxy-page-title>
    <glxy-page-actions>
      <ng-content #toolbar_actions></ng-content>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <uikit-async-ui
    [loading]="fetchState.isLoading$ | async"
    [error]="(fetchState.isSuccess$ | async) === false"
    [data]="fetchState.workResults$ | async"
    loadingMargin="auto"
    errorMargin="auto"
  >
    <ng-container *successData="let data">
      <email-builder
        #emailBuilder
        [emailContent]="data"
        [placeholderLogoUrl]="placeholderLogo$ | async"
        [advancedSections]="advancedSections"
        [locale]="locale"
        [previewHydrationParams]="previewHydrationData$ | async"
        (emailContentChanged)="this.handleContentChanges($event)"
        (emailRenderUpdated)="this.handleRenderUpdated($event)"
        (emailRenderFailed)="this.handleRenderFailed()"
        [dynamicComponents]="dynamicComponents"
      >
        <div class="container" preview_header>
          <app-preview-business-selector
            [hydrationData]="previewHydrationData$ | async"
            (businessSelected)="handleBusinessSelected($event)"
          ></app-preview-business-selector>
        </div>
      </email-builder>
    </ng-container>
  </uikit-async-ui>
</glxy-page>
